import {get, moment, omit, difference, keys, keyBy, createReducer} from 'helpers';

export const index = createReducer({}, {

  DIARY_UPDATE: (state, { diary, generateId }) => ({
    ...state,
    [diary.id || generateId('id')]: {
      id: generateId('id'),
      ...state[diary.id],
      ...diary,
    }
  }),

  DIARY_DELETE: (state, { id }) => {
    return omit(state, id);
  },

  DIARY_MOOD_CHANGE: (state, { mood, timestamp, generateId, diaryId = generateId('diaryId') }) => ({
    ...state,
    [diaryId]: {
      ...state[diaryId],
      id: diaryId,
      date: mood.date,
      subject: 'My Mood',
      time: moment.unix(timestamp).format('h:mm A'),
    }
  }),

  DIARY_CHECK_IN: (state, { id, timestamp, timestamp_today, date, text, checkInType }) => {
    if (!text) {
      return omit(state, id);
    }
    return {
      ...state,
      [id]: {
        ...state[id],
        id,
        text,
        date: date.unix(),
        time: date.unix() == timestamp_today ? moment.unix(timestamp).format('h:mm A') : '11:59 PM',
        subject: get({
          reflections: 'Reflections',
          midday: 'Daily Check-in',
          morning_thoughts: 'Morning Thoughts',
        }, checkInType, checkInType)
      }
    }
  },

  SERVER_DATA_RECEIVED: (state, action) => {
    const removed = difference(keys(state), action.existingElementIds.journals);
    if (action.journals.length || removed.length) {
      return omit({
        ...state,
        ...keyBy(action.journals, 'id'),
      }, removed);
    }
    return state;
  },

  TESTING_DELETE_ALL: () => ({}),

});
